
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/black-friday-cyber-monday-sales/[[...slug]]",
      function () {
        return require("private-next-pages/black-friday-cyber-monday-sales/[[...slug]].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/black-friday-cyber-monday-sales/[[...slug]]"])
      });
    }
  